import React from "react";
import { Eye, EyeOff, Info } from "lucide-react";

const fmtData = new Intl.DateTimeFormat("it-IT", { timeZone: "Europe/Rome", day: "2-digit", month: "2-digit" });
const fmtDataLunga = new Intl.DateTimeFormat("it-IT", { timeZone: "Europe/Rome", day: "2-digit", month: "2-digit", year: "numeric" });
const fmtOra = new Intl.DateTimeFormat("it-IT", { timeZone: "Europe/Rome", hour: "2-digit", minute: "2-digit" });

export const tracciata = (email) => !!email?.tracking_id && email.folder === "inviate";

// Badge sulla riga Inviate: "Letta GG/MM HH:MM" verde oppure "Non ancora aperta" grigio
export function SpuntaLettura({ email }) {
  if (!tracciata(email)) return null;
  const letta = !!email.letta_il;
  const d = letta ? new Date(email.letta_il * 1000) : null;
  return (
    <span
      className={`lettura-badge ${letta ? "ok" : ""}`}
      title={letta ? `Aperta la prima volta il ${fmtDataLunga.format(d)} alle ${fmtOra.format(d)}${email.letta_n > 1 ? ` (${email.letta_n} aperture)` : ""}` : "Il destinatario non ha ancora aperto l'email"}
      data-testid={`lettura-badge-${email.id}`}
    >
      {letta ? <Eye size={11} strokeWidth={3} /> : <EyeOff size={11} strokeWidth={2.6} />}
      {letta ? `Letta ${fmtData.format(d)} ${fmtOra.format(d)}` : "Non ancora aperta"}
    </span>
  );
}

// Riquadro nel dettaglio dell'email inviata: Inviata · Letta il … alle … / Non ancora aperta
export function LetturaBox({ email }) {
  if (!tracciata(email)) return null;
  const letta = !!email.letta_il;
  const d = letta ? new Date(email.letta_il * 1000) : null;
  return (
    <div className={`lettura-box ${letta ? "ok" : ""}`} data-testid="lettura-box">
      {letta ? <Eye size={18} strokeWidth={2.4} /> : <EyeOff size={18} strokeWidth={2.2} />}
      <div className="lettura-testo">
        <strong data-testid="lettura-stato">{letta ? `Letta il ${fmtDataLunga.format(d)} alle ${fmtOra.format(d)}` : "Inviata · Non ancora aperta"}</strong>
        <span>
          {letta
            ? `Prima apertura da parte del destinatario${email.letta_n > 1 ? ` · ${email.letta_n} aperture in totale` : ""}`
            : "Inviata al destinatario, nessuna apertura rilevata finora"}
        </span>
      </div>
      <span className="lettura-nota con-tip tip-sx-int" data-tip="Il rilevamento funziona solo se il client di posta del destinatario carica le immagini; se le blocca, l'apertura non viene rilevata.">
        <Info size={15} strokeWidth={2.2} />
      </span>
    </div>
  );
}
